<template>
  <el-dropdown
    size="mini"
    split-button
    type="primary"
    class="r-dropdown"
    @command="handleClick"
    trigger="click"
  >
    <el-input
      size="mini"
      :controls="false"
      class="r-input dark"
      :disabled="readonly"
      v-model="value"
      :placeholder="placeholder"
      @change="change($event)"
      @mousedown.stop
    />
    <el-dropdown-menu slot="dropdown" :append-to-body="false">
      <el-dropdown-item
        v-for="item in dropdownItems"
        :key="item.id"
        :command="item.name"
        >{{ item.name }}</el-dropdown-item
      >
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: [
    "comp",
    "emitter",
    "ikey",
    "placeholder",
    "readonly",
    "type",
    "getData",
    "putData"
  ],
  data() {
    return {
      dropdownItems: [],
      value: this.initial || 0
    };
  },
  methods: {
    change(value) {
      this.value = value;
      this.update();
    },
    update() {
      if (this.ikey) this.putData(this.ikey, this.value);
      this.emitter.trigger("process");
    },
    handleClick(val) {
      this.value = val;
    }
  },
  mounted() {
    for (let i = 1; i < 4; i++) {
      this.dropdownItems.push({ id: i, name: `model ${i}` });
    }
    this.value = this.getData(this.ikey);
  }
};
</script>

<style lang="scss">
.node {
  .r-dropdown {
    display: block;
    border-radius: var(--border-radius);
    border: 1px solid;
    box-sizing: border-box;
    color: var(--white_white) !important;
    width: 100px;
    border-color: var(--dividers_low_contrast) !important;
    .el-dropdown-menu {
      position: absolute;
      top: 40px !important;
      left: 0 !important;
      margin: 0 !important;
    }

    .el-button {
      padding: 0;
      box-sizing: border-box;
      border: none;
      background: none;
      &-group {
        display: flex;
        width: 100%;
        overflow: hidden;
        background-color: var(--bg_panel_secondary) !important;
      }
    }
    .r-input {
      height: 26px;
    }
    .r-input,
    .r-input.is-disabled {
      width: 80px;
      .el-input__inner {
        border: none !important;
        background: none !important;
      }
    }
    .r-input.is-disabled {
      .el-input__inner {
        cursor: initial;
      }
    }
  }
}
</style>
